import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { DropdownButton } from 'react-bootstrap';
import { toastWarning } from '../../util/toastUtils';
import {
  SALES_CATALYST, SALES_CATALYST_INPUTS,
  SALES_CATALYST_TARGET_MARKET, SALES_CATALYST_DEFAULT_SELECTED_TAB,
  SALES_ATTITUDE_REPORT_NAME,
  SALES_DEMO_REPORT_NAME,
  SALES_ATTITUDE_REPORT_TOP_VALUE,
  DEFINITION_HEADER_LENGTH,
  SALES_CATALYST_REDUCERS_BASE,
  SALES_CATALYST_HEADERINFO_REPORT_NAME,
  SALES_CATALYST_SAMPLE_WEIGHTED_REACH_REPORT_NAME,
  SALES_CATALYST_MEDIA_PACKAGE,
  SALES_CATALYST_COMPETITION,
  SALES_CATALYST_RESET_ALL,
  SALES_CATALYST_DATA_SELECTION,
  SALES_CATALYST_DATA_SUBENTITIES,
  SC_SELECTED_SUBENTITY_LIST,
  SALES_LESS_BASE_WARNING,
  SALES_CATALYST_DATA_COMPETITOR,
  SALES_CATALYST_MAX_COMPETITORS,
  SMART_SEARCH_SALES_CATALYST_PAGE,
  SALES_CATALYST_FEATUREID,
} from '../../constants';
import SalesCatalystInputsTable from './SalesCatalystInputsTable';
import SalesCatalystTargetMarket from './SalesCatalystTargetMarket/SalesCatalystTargetMarket';
import SalesCatalystMediaPackage from './SalesCatalystMediaPackage/SalesCatalystMediaPackage';
import SalesCatalystCompetition from './SalesCatalystCompetition/SalesCatalystCompetition';
import * as studyActions from '../../actions/studyActions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import * as definitionActions from '../../actions/definitionActions';
import CommonStudySelector from '../common/CommonStudySelector';
import { createExpressionList, getDataSelectionData, createSSDataOptions, availableToAddSpecificSelection } from '../../util/SalesCatalystUtils';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import clearBaseIcon from '../../images/insight360/clear-field-icon_190-190-190.png';
import settingsIcon from '../../images/salescatalyst/configuration_icon_default.png';
// import SmartSearch from '../common/SmartSearch/SmartSearch';
import * as quickReportsActions from '../../actions/quickReportsActions';
import * as crosstabActions from '../../actions/crosstabActions';
import InlineEdit from '../common/InlineEdit/InlineEdit';
import editIconActive from '../../images/insight360/edit-icon_active.png';
import SaveDefinitionLabelPopupScreen from '../common/SaveDefinitionLabelPopupScreen';
import {
  SALES_CATALYST_DEFINITION_LENGTH_WARNING,
  SC_SUBENTITIES_LIST_DUPLICATE_WARNING,
  SC_SAMPLE_VALUE_NULL_ERROR_MESSAGE,
  SC_INVALID_COMBINATION_MSG,
} from '../../messages/messages';
import * as insight360Actions from '../../actions/insight360Actions';
import * as preferencesActions from '../../actions/preferencesActions';
import SalesCatalystConfigurationScreen from './SalesCatalystConfiguration/SalesCatalystConfigurationScreen';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import { saveTrackingData } from '../../util/trackerUtils';

const validateStudyResultModal = {
  width: '60%',
  height: '40px',
  left: '20%',
  top: '20%',
};

const modalSettingStyle = {
  width: '51%',
  height: '40px',
  left: '24%',
  top: '20%',
};

const modalConfigurationStyle = {
  width: '79%',
  left: '22%',
  top: '0',
  bottom: '0',
  margin: '0',
  borderRadius: '0',
  animation: 'animateLftToRgt 1s 1',
  WebkitAnimation: 'animateLftToRgt 1s 1',
};

class SalesCatalystContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSelection: {
        targetMarket: [],
        entity: [],
        competitor: [],
        category: {},
        brand: [],
        targetEntityOverlap: {},
        subEntities: [],
      },
      headerInfo: {},
      salesCatalystBase: this.props.salesCatalystBase !== undefined ?
        this.props.salesCatalystBase : undefined,
      selectedTemplates: {},
      emptyResponse: [],
      tempDataSelection: {},
      tempSalesCatalystBase: {},
      tempStudyInfo: {},
      resultForTemplateChange: false,
      smartSearchDataOptions: createSSDataOptions(SALES_CATALYST_DEFAULT_SELECTED_TAB),
      smartSearchDataReqOptions: createSSDataOptions(),
      isBaseInEditMode: false,
      baseLabelUpdateObject: {},
      baseLabelUpdateCallBack: '',
      popupCloseButtonClick: true,
      study: {},
      studyChangeBaseValid: false,
      setSalesCatalystBaseFlag: false,
      ssResetInputInfo: false,
      hideOkButton: false,
      popupApplyVisible: false,
      baseBtnDisabled: true,
    };
    this.smartSearchBox = React.createRef();
  }

  /* componentDidMount() {
    this.fetchActivitiesTemplateList();
    if (this.props.salesCatalystPrefenceFlag &&
      typeof (this.props.salesCatalystStudyInfo) !== 'undefined') {
      this.setSelectedSCStudy(this.props.salesCatalystStudyInfo, true);
    }
  } */

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.dataSelection) {
      this.setState({ dataSelection: {} });
    } else if (this.state.dataSelection !== nextProps.dataSelection) {
      this.setState({ dataSelection: nextProps.dataSelection });
    }

    if (nextProps.smartSearchStudy) {
      this.setState({ smartSearchStudy: nextProps.smartSearchStudy });
    }

    if (this.props.salesCatalystBase !== nextProps.salesCatalystBase) {
      this.setState({ salesCatalystBase: nextProps.salesCatalystBase });
    }

    if (this.props.selectedTemplates !== nextProps.selectedTemplates) {
      this.setState({ selectedTemplates: nextProps.selectedTemplates });
    }

    if (nextProps.salesCatalystStudyInfo) {
      // !_.isEqual(this.props.salesCatalystStudyInfo, nextProps.salesCatalystStudyInfo
      if (!_.isEqual(this.props.salesCatalystStudyInfo, nextProps.salesCatalystStudyInfo)
        || this.props.activeAccountId !== nextProps.activeAccountId) {
        const token = nextProps.loginResponse.data.token;
        const userId = nextProps.loginResponse.data.uid;
        const accountId = nextProps.activeAccountId;
        const productNo = nextProps.productNo;
        this.props.salesCatalystActions.getActivitiesTemplateList({ token, userId, accountId, productNo });
      }
    }

    if (this.props.selectedTab !== nextProps.selectedTab) {
      this.setState({
        smartSearchDataOptions: createSSDataOptions(nextProps.selectedTab),
        smartSearchDataReqOptions: (nextProps.selectedTab === SALES_CATALYST_COMPETITION)
          ? createSSDataOptions(nextProps.selectedTab) : createSSDataOptions(),
      });
    }

    if (!this.props.salesCatalystPrefenceFlag && nextProps.salesCatalystPrefenceFlag) {
      this.setSelectedSCStudy(this.state.smartSearchStudy, true);
    }

    if (this.props.configPopupShow !== nextProps.configPopupShow) {
      /* this.setState({ configScreenTabInfo: nextProps.configPopupShow.defaultTab }); */
      if (nextProps.configPopupShow.show) {
        this.configurationScreen.show();
        this.setState({
          ssResetInputInfo: true,
        }, () => {
          this.setState({
            ssResetInputInfo: false,
          });
        });
      }
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({
          baseBtnDisabled: false,
          colBtnDisabled: false,
        });
      } else {
        this.setState({
          baseBtnDisabled: true,
          colBtnDisabled: true,
        });
      }
    }
  }

  componentDidMount() {
    const { salesCatalystPrefenceFlag, salesCatalystStudyInfo } = this.props;
    if (salesCatalystPrefenceFlag &&
      typeof (salesCatalystStudyInfo) !== 'undefined') {
      this.setSelectedSCStudy(salesCatalystStudyInfo, true);
      this.fetchActivitiesTemplateList();
    } else if ((typeof (salesCatalystStudyInfo) !== 'undefined') && !_.isEmpty(salesCatalystStudyInfo)) {
      this.fetchActivitiesTemplateList();
    }
  }

  setPreferenceFlag = value => {
    this.props.preferencesActions.setPreferenceFlag('salesCatalyst', value);
  }

  getPersonaLabelAndExp = (entity, targetMarket) => {
    const personaLabels = [];
    const personaExpressions = [];
    const Labels = `${entity[0].label} AND ${targetMarket[0].label}`;
    const Expressions = `(${entity[0].expression}) AND (${targetMarket[0].expression})`;
    personaLabels.push(Labels);
    personaExpressions.push(Expressions);
    const headerInfo = {
      label: personaLabels,
      expression: personaExpressions,
    };
    return headerInfo;
  };

  setSelectedSCStudy = (studyInfo, flag = false) => {
    const updatedStudy = {
      ...studyInfo,
      wt: 1,   // updating weight type to population by default.
    };
    if (flag) {
      this.setState({ hideOkButton: true });
    } else {
      this.setState({ hideOkButton: false });
    }
    this.setState({ tempStudyInfo: updatedStudy, setSalesCatalystBaseFlag: false });

    if (this.props.scDataSelection && (this.props.scDataSelection.targetMarket.length === 0 &&
      this.props.scDataSelection.entity.length === 0 &&
      this.props.scDataSelection.competitor.length === 0 &&
      this.props.scDataSelection.brand.length === 0 &&
      this.state.salesCatalystBase === undefined)) {
      this.props.salesCatalystActions.setSalesCatalystStudy(updatedStudy);
      this.updateSessionStudy(updatedStudy);
      /* this.cleanScConfigData(); */
    } else {
      this.validateInputsDataOnStudyChange(updatedStudy);
    }
  };

  setSalesCatalystBaseInfo = baseInfo => {
    this.setState({ setSalesCatalystBaseFlag: true });
    this.props.salesCatalystActions.setSalesBase(baseInfo)
      .then(() => {
        if (this.props.scDataSelection && (this.props.scDataSelection.targetMarket.length > 0 ||
          this.props.scDataSelection.entity.length > 0 ||
          this.props.scDataSelection.competitor.length > 0 ||
          this.props.scDataSelection.brand.length > 0)) {
          this.validateInputsDataOnStudyChange(this.state.smartSearchStudy);
        }
      });
  }

  /**
 * Method to close the dropdowns of SalesCatalyst Brand and pitch
 */
  closeSalesCatalystSelection = () => {
    this.setState({
      popupBrandVisible: false,
      popupPitchVisible: false,
      popupApplyVisible: false,
    });
  }

  setSalesCatalystBase = () => {
    const { insight360PersonalLabels, expressionFormed, validExpression,
    } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    if (validExpression && this.props.salesCatalystBase === undefined) {
      const label = insight360PersonalLabels.join(' ');
      const expression = expressionFormed.join(' ');
      const baseInfo = {
        label,
        expression,
      };
      this.setSalesCatalystBaseInfo(baseInfo);
      this.closeSalesCatalystSelection();
      this.smartSearchBox.current.resetAll();
      // this.props.gridData.kpiInfo = undefined;
    }
  }

  onModalPopupXButtonClick = () => {
    if (this.state.popupCloseButtonClick) {
      this.state.baseLabelUpdateCallBack(false);
    } else {
      this.setState({
        popupCloseButtonClick: true,
      });
    }
  };

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.BaseDataGrid,
    TargetDataGrid: this.props.TargetDataGrid,
    RecycleElements: this.props.recycleElements,
  });

  validateInputsDataOnStudyChange = studyInfo => {
    if (this.props.scDataSelection && (this.props.scDataSelection.targetMarket.length > 0 ||
      this.props.scDataSelection.entity.length > 0 ||
      this.props.scDataSelection.competitor.length > 0 ||
      this.props.scDataSelection.brand.length > 0 ||
      this.state.salesCatalystBase !== undefined ||
      this.state.salesCatalystBase === undefined)) {
      /**
       *  Expression List index order
       *  0 - targetMarket
       *  1 - entity
       *  2 - competitor1
       *  3 - competitor2
       *  4 - competitor3
       *  5 - brand
       *  6 - base
       * */
      const list = createExpressionList(
        this.props.scDataSelection.targetMarket,
        this.props.scDataSelection.entity,
        this.props.scDataSelection.competitor,
        this.props.scDataSelection.brand
      );

      const productNo = studyInfo.pn;
      const divisor = 1;
      const weightType = studyInfo.wt === 3 ? 1 : studyInfo.wt;
      const token = this.props.loginResponse.data.token;
      const uid = this.props.loginResponse.data.uid;
      const accountId = this.props.activeAccountId;
      const expressionList = list.expressionList;
      this.props.salesCatalystActions.getSampleWeightedReachInfo({
        uid,
        accountId,
        token,
        expressionList,
        productNo,
        divisor,
        weightType,
        reportName: SALES_CATALYST_SAMPLE_WEIGHTED_REACH_REPORT_NAME,
      })
        .then(response => {
          this.reloadTablesOnStudyChange(response, studyInfo);
        });
    }
  }

  reloadTablesOnStudyChange = (response, studyInfo) => {
    if (response.status === 400) {
      const deletedExpressionsList = [];
      deletedExpressionsList.push(this.state.salesCatalystBase);
      const deletedContent = [...deletedExpressionsList];
      this.setState({
        studyChangeBaseValid: false,
        setSalesCatalystBaseFlag: true,
      }, () => {
        this.showValidateStudyResultPopup(deletedContent, false);
      });
    } else if (response.status === 200) {
      this.setPreferenceFlag(false);
      if (this.state.salesCatalystBase === undefined) {
        this.setState({
          studyChangeBaseValid: undefined,
        }, () => {
          this.uploadNewStudyData(response.data, studyInfo);
        });
      } else {
        const productNo = studyInfo.pn;
        const divisor = 1;
        const weightType = studyInfo.wt === 3 ? 1 : studyInfo.wt;
        const token = this.props.loginResponse.data.token;
        const uid = this.props.loginResponse.data.uid;
        const accountId = this.props.activeAccountId;
        const expressionList = [];
        expressionList.push(this.state.salesCatalystBase.expression);
        this.props.salesCatalystActions.getSampleWeightedReachInfo({
          uid,
          accountId,
          token,
          expressionList,
          productNo,
          divisor,
          weightType,
          reportName: SALES_CATALYST_SAMPLE_WEIGHTED_REACH_REPORT_NAME,
        }).then(baseResponse => {
          let isBaseSampleValid = true;
          if (baseResponse.status === 200) {
            isBaseSampleValid = baseResponse.data[0].sample > 0;
          }
          this.setState({
            studyChangeBaseValid: isBaseSampleValid,
          }, () => {
            this.uploadNewStudyData(response.data, studyInfo, isBaseSampleValid);
          });
        });
      }
    }
  }

  uploadNewStudyData = (response, studyInfo, isBaseSampleValid) => {
    const updatedData = getDataSelectionData(response, this.props.scDataSelection,
      this.state.salesCatalystBase, isBaseSampleValid);
    this.setState({
      tempDataSelection: updatedData.dataSelection,
      tempSalesCatalystBase: updatedData.salesCatalystBase,
    });
    if (updatedData.deletedDetails.length > 0) {
      const deletedContent = [...updatedData.deletedDetails];
      this.showValidateStudyResultPopup(deletedContent, false);
    } else {
      this.props.salesCatalystActions.resetSalesCatalystScreen(_.camelCase(this.props.selectedTab),
        createSSDataOptions(SALES_CATALYST_RESET_ALL), this.state.studyChangeBaseValid, true)
        .then(() => {
          this.updateSessionStudy(studyInfo);
          this.props.salesCatalystActions.setSalesCatalystStudy(studyInfo)
            .then(() => {
              this.applySelectedSCStudy();
            });
        });
    }
  }

  showValidateStudyResultPopup = (data, type) => {
    this.setState({
      emptyResponse: data,
      resultForTemplateChange: type,
    });
    this.validateStudyResultModal.show();
  }

  resetAfterBaseApplyFailure = () => {
    this.setState({ setSalesCatalystBaseFlag: false, emptyResponse: [] });
    this.props.salesCatalystActions.setSalesCatalystStudy(this.state.tempStudyInfo);
    this.props.salesCatalystActions.resetSalesCatalystScreen(_.camelCase(this.props.selectedTab),
      createSSDataOptions(SALES_CATALYST_RESET_ALL));
  }

  applySelectedSCStudyAfterReset = () => {
    this.setState({ emptyResponse: [] });
    this.updateSessionStudy(this.state.tempStudyInfo);
    this.props.salesCatalystActions.setSalesCatalystStudy(this.state.tempStudyInfo);
    this.props.salesCatalystActions.resetSalesCatalystScreen(_.camelCase(this.props.selectedTab),
      createSSDataOptions(SALES_CATALYST_RESET_ALL))
      .then(() => {
        this.applySelectedSCStudy();
      });
  }

  applySelectedSCStudy = () => {
    // const token = this.props.loginResponse.data.token;
    // const userId = this.props.loginResponse.data.uid;
    // const accountId = this.props.activeAccountId;
    // const productNo = this.props.productNo;
    // this.props.salesCatalystActions.getActivitiesTemplateList({ token, userId, accountId, productNo }
    // ).then(() => {
    /* this.cleanScConfigData(); */
    if (this.state.tempDataSelection) {
      const dataSelection = this.state.tempDataSelection;
      let targetMarket = false;
      let mediaPackage = false;
      let competition = false;
      if (dataSelection.targetMarket.length > 0 && dataSelection.entity.length > 0) {
        targetMarket = true;
        mediaPackage = true;
      }

      if (dataSelection.targetMarket.length > 0 && dataSelection.entity.length > 0
        && dataSelection.competitor.length > 0) {
        competition = true;
      }
      this.props.salesCatalystActions.updateSelectionsData(
        this.state.tempDataSelection,
        this.state.tempSalesCatalystBase,
      ).then(() => {
        this.props.salesCatalystActions.updateDataOnScreen(
          {
            targetMarket,
            mediaPackage,
            competition,
          }
        ).then(() => {
          this.runSalesCatalyst(targetMarket, competition, mediaPackage);
        });
      });
    }
    // });
  }

  /* cleanScConfigData = () => {
    this.props.salesCatalystActions.deleteSalesCatalystSelection(
      SALES_CATALYST_DATA_SELECTION,
      _.camelCase(SALES_CATALYST_DATA_SUBENTITIES),
      SALES_CATALYST_DATA_SUBENTITIES);
    this.props.salesCatalystActions.setCofigurationPackageData(
      undefined,
      SC_SELECTED_SUBENTITY_LIST
    );
  } */

  isTableSelectionsEmpty = value => {
    if (value === 'brand') {
      return (this.state.brandSelection.audience.length === 0) &&
        (this.state.brandSelection.subAudience.length === 0) &&
        (this.state.brandSelection.competitors.length === 0) &&
        (this.state.brandSelection.market.length === 0);
    } if (value === 'pitch') {
      return (this.state.pitchSelection.audience.length === 0) &&
        (this.state.pitchSelection.subAudience.length === 0) &&
        (this.state.pitchSelection.competitors.length === 0) &&
        (this.state.pitchSelection.market.length === 0);
    }
    return false;
  }

  checkSCTabHasData = () => {
    // _.find(this.state.brandSelection, o => o.length > 0) !== undefined ||
    // _.find(this.state.pitchSelection, o => o.length > 0) !== undefined
    let flag = false;
    if (this.props.dataOnScreen.targetMarket || this.props.mediaPackage) {
      flag = true;
    }
    return flag;
  };

  addInputDataPointsSelection = (headerInfo, mainCategory, categorySelection) => {
    const { loginResponse, activeAccountId, productNo } = this.props;
    const updateTextBoxFlag = true;
    const expressionList = [];
    const personaLabel = [];
    expressionList.push(headerInfo.expression);
    personaLabel.push(headerInfo.label);
    const headerInfoObj = {
      label: personaLabel,
      expression: expressionList,
    };

    this.props.salesCatalystActions.getSalesHeaderInfo(
      loginResponse.data.token,
      loginResponse.data.uid,
      activeAccountId,
      headerInfoObj,
      SALES_CATALYST_HEADERINFO_REPORT_NAME,
      productNo,
      updateTextBoxFlag)
      .then(response => {
        if (response === undefined) {
          toastWarning(SC_INVALID_COMBINATION_MSG);
        } else {
          if (response.status === 200) {
            const headerData = response.data[0].headers[1];
            headerInfo.sample = headerData.sample;
            headerInfo.weighted = headerData.weighted;
            headerInfo.pct = headerData.pct;
          }
          this.addInputDataPointsSelectionData(headerInfo, mainCategory, categorySelection);
        }
      }).catch(response => console.warn(response));
  }

  addInputDataPointsSelectionData = (headerInfo, mainCategory, categorySelection) => {
    if (_.find(this.props.scDataSelection[categorySelection],
      o => o.expression === headerInfo.expression)) {
      toastWarning(SC_SUBENTITIES_LIST_DUPLICATE_WARNING);
    } else if (headerInfo.sample === 0) {
      toastWarning(SC_SAMPLE_VALUE_NULL_ERROR_MESSAGE);
    } else {
      this.props.salesCatalystActions.addSalesCatalystDataPoints(
        headerInfo,
        mainCategory,
        categorySelection
      );
      saveTrackingData({
        uid: this.props.loginResponse.data.uid,
        accid: this.props.activeAccountId,
        action: SMART_SEARCH_SALES_CATALYST_PAGE,
        moduleName: 'SalesCatalyst',
        subModule: this.props.selectedTab,
        productNo: this.props.salesCatalystStudyInfo !== undefined ?
          this.props.salesCatalystStudyInfo.pn : undefined,
        attributes: { [categorySelection]: { label: headerInfo.label, expression: headerInfo.expression } },
      });
    }

    if (this.props.dataOnScreen[_.camelCase(this.props.selectedTab)] !== undefined &&
      this.props.dataOnScreen[_.camelCase(this.props.selectedTab)] === true &&
      _.find(this.state.smartSearchDataReqOptions, o => (o === mainCategory)) === undefined &&
      categorySelection !== _.camelCase(SALES_CATALYST_DATA_SUBENTITIES)) {
      this.props.salesCatalystActions.setDataOnScreenVal(
        _.camelCase(this.props.selectedTab),
        false
      );
    }
  }

  fetchActivitiesTemplateList() {
    const token = this.props.loginResponse.data.token;
    const userId = this.props.loginResponse.data.uid;
    const accountId = this.props.activeAccountId;
    const productNo = this.props.productNo;
    this.props.salesCatalystActions.getActivitiesTemplateList({ token, userId, accountId, productNo });
  }

  resetSalesCatalyst = () => {
    if (this.props.selectedTab === SALES_CATALYST_INPUTS) {
      this.props.salesCatalystActions.resetSalesCatalyst();
      document.getElementById('brand-search-box').value = '';
      document.getElementById('pitch-search-box').value = '';
      this.setState({ showBrandSearchResult: false });
      this.setState({ showPitchSearchResult: false });
    } else {
      this.props.salesCatalystActions.resetSalesCatalystScreen(_.camelCase(this.props.selectedTab),
        this.state.smartSearchDataOptions);
    }
  }

  runSalesCatalyst = (runTargetMarket = false, runCompetition = false, runMediaPackage = false) => {
    const { loginResponse, productNo, activeAccountId,
      entity, targetMarket, competitor, scAttitudesDisplayList, scDemoDisplayList } = this.props;

    if (targetMarket.length > 0 && entity.length > 0) {
      runTargetMarket = true;
      runMediaPackage = true;
    }
    // logic for competition goes here
    if (targetMarket.length > 0 && entity.length > 0 && competitor.length > 0) {
      runCompetition = true;
    }
    this.props.salesCatalystActions.runSalesCatalyst(runTargetMarket,
      runCompetition, runMediaPackage)
      .then(() => {
        if (entity.length > 0 && targetMarket.length > 0) {
          const headerInfo = this.getPersonaLabelAndExp(entity, targetMarket);

          if ((scAttitudesDisplayList.length === 0 && scDemoDisplayList.length === 0)) {
            this.props.salesCatalystActions.attitudeMarketDataList(loginResponse.data.token,
              loginResponse.data.uid,
              activeAccountId, productNo, headerInfo.label, headerInfo.expression,
              SALES_ATTITUDE_REPORT_NAME,
              SALES_ATTITUDE_REPORT_TOP_VALUE);

            this.props.salesCatalystActions.getDemoMarketDataList(loginResponse.data.token,
              loginResponse.data.uid,
              activeAccountId, productNo, headerInfo.label, headerInfo.expression,
              SALES_DEMO_REPORT_NAME,
              SALES_ATTITUDE_REPORT_TOP_VALUE);
          }

          /* this.props.salesCatalystActions.getSalesDataRequestInfo(loginResponse.data.token,
            loginResponse.data.uid,
            activeAccountId, headerInfo,
            SALES_CATALYST_HEADERINFO_REPORT_NAME, this.props.productNo); */
        }
      });
  }


  handleClearSalesBaseClick = () => {
    this.setState({ setSalesCatalystBaseFlag: false });
    this.props.salesCatalystActions.handleClearSalesBaseClick()
      .then(() => {
        this.validateInputsDataOnStudyChange(this.state.smartSearchStudy);
      });
  }

  toggleBaseEditMode = value => {
    this.setState({
      isBaseInEditMode: value,
    });
  };

  updateSessionStudy = study => {
    const { salesCatalystActions, sessionData } = this.props;
    if (!_.isEmpty(sessionData)) {
      salesCatalystActions.updateSalesCatalystSessionStudy(study, sessionData);
    }
  }

  updateBaseHeaderLabel = (value, callback) => {
    const expression = [];
    const definationId = null;
    const expressionObj = {
      id: null,
      title: value.trimStart(),
      expression: this.state.salesCatalystBase.expression,
    };
    expression.push(expressionObj);

    const labelUpdateData = {
      defId: definationId,
      defName: '',
      expressions: expression,
    };
    this.setState({
      baseLabelUpdateObject: labelUpdateData,
      baseLabelUpdateCallBack: callback,
    });

    this.confirmationModal.show();
  };

  refreshDefinationdata = () => {
    this.props.definitionActions.getDefinitionTreeLoad(
      this.props.loginResponse.data.token,
      this.props.salesCatalystStudyInfo.ss === 'SIMMONS' ? 1 : 2,
      this.props.activeAccountId,
      this.props.productNo,
    );
  }


  onPersonaHeaderLabelSave = definationObject => {
    const mainCategory = SALES_CATALYST_REDUCERS_BASE;
    const subCategory = undefined;
    const category = { mainCategory, subCategory };
    const headerLabelUpdateObject = _.clone(
      this.state.baseLabelUpdateObject,
    );

    if (
      definationObject.definitionFolderId !==
      headerLabelUpdateObject.defId
    ) {
      headerLabelUpdateObject.defId =
        definationObject.definitionFolderId;
      headerLabelUpdateObject.expressions[0].id = null;
    }
    headerLabelUpdateObject.defName =
      definationObject.definitionFolderName;

    this.props.salesCatalystActions.saveDataToDefinitionFolder(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.props.productNo,
      headerLabelUpdateObject,
      this.state.baseLabelUpdateCallBack,
      this.refreshDefinationdata,
      undefined,
      category
    );
    this.setState(
      {
        popupCloseButtonClick: false,
      },
      () => {
        this.confirmationModal.hide();
      },
    );
  };

  validateBaseHeaderLabel = (value, callback) => {
    // check the label max length equal to 64
    const callBackArg = value.length < DEFINITION_HEADER_LENGTH;
    if (callBackArg) {
      callback(true);
    } else {
      callback(false, SALES_CATALYST_DEFINITION_LENGTH_WARNING);
    }
  };

  showSCConfigurations = (val, tabInfo) => {
    this.props.salesCatalystActions.showCofigurationScreen(val, tabInfo);
  }

  showInputsDataPointsSelection = (type, flag) => {
    if (this.smartSearchBox.current.state.validExpression) {
      if (type === SALES_CATALYST_DATA_SELECTION) {
        this.setState({
          popupApplyVisible: flag,
        });
      }

      if (flag === false) {
        this.smartSearchBox.current.resetAll();
        // this.props.kpiInfo = undefined;
      }
    }
  };

  /**
 * Adding Audience(1) , SubAudience(3), Competitors(3), Market(1)
 * for Brand or Pitch of salesCatalyst reducer through the fucntion
 * addInputDataPointsSelection exposed through props.
 */
  validateAddSpecificSelection = (data, category, type, stateValue = undefined) => {
    let { insight360_tags, selectedCategoryRecType, definationTargetData,
      insight360PersonalLabels, expressionFormed,
    } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    if (stateValue) {
      insight360_tags = stateValue.insight360_tags;
      selectedCategoryRecType = stateValue.selectedCategoryRecType;
      definationTargetData = stateValue.definationTargetData;
      insight360PersonalLabels = stateValue.insight360PersonalLabels;
      expressionFormed = stateValue.expressionFormed;
    }
    if (availableToAddSpecificSelection(data, category)) {
      let expressionsId = null;
      let definationId = null;
      if (selectedCategoryRecType === 'D') {
        const tagName = _.clone(insight360_tags);
        const object = _.clone(definationTargetData).find(
          obj => obj.title === tagName[0].trimStart(),
        );
        if (!_.isEmpty(object) && typeof object.expressionId !== 'undefined') {
          expressionsId = object.expressionId;
          definationId = object.ovDefinitionId;
        }
      } else {
        expressionsId = null;
        definationId = null;
      }
      this.addInputDataPointsSelection({
        label: insight360PersonalLabels.join(' '),
        expression: expressionFormed.join(' '),
        sample: this.props.kpiInfo.intab,
        weighted: this.props.kpiInfo.weighted,
        expId: expressionsId,
        defId: definationId,
      },
        type,
        _.camelCase(category),
      );
    }
    this.showInputsDataPointsSelection(type, false);
  };

  render() {
    return (
      <div className="row fullWidth searchBar sales-catalyst">
        <Modal
          title={this.state.setSalesCatalystBaseFlag === false ? 'Validate Study Results' : 'Validate Base Selection'}
          ref={node => (this.validateStudyResultModal = node)}
          dialogStyles={validateStudyResultModal}
          hideCloseButton
        >
          <div>
            {this.state.setSalesCatalystBaseFlag === false &&
              <div>
                <p>The following items are not available in the current study:</p>
                <p>
                  <strong>
                    Study Name: {this.state.resultForTemplateChange ?
                      this.state.smartSearchStudy.sd :
                      this.state.tempStudyInfo.sd}
                  </strong>
                </p>
                {this.state.studyChangeBaseValid !== undefined &&
                  !this.state.studyChangeBaseValid &&
                  <p>
                    <strong>
                      BASE is Invalid: {this.state.salesCatalystBase ? this.state.salesCatalystBase.label : ''}
                    </strong>
                  </p>
                }
              </div>
            }
            {this.state.setSalesCatalystBaseFlag === true &&
              <div>
                <p>Data Points are not available for this combination:</p>
                <p>
                  <strong>
                    BASE: {this.state.salesCatalystBase ? this.state.salesCatalystBase.label : ''}
                  </strong>
                </p>
              </div>
            }
            <div>
              <h3>Sales Catalyst Data Points(s)</h3>
              <div className="bc-study-data-point margin-bottom-10">
                {this.state.setSalesCatalystBaseFlag === false &&
                  (this.state.studyChangeBaseValid === undefined ||
                    this.state.studyChangeBaseValid) &&
                  <ul>
                    {this.state.emptyResponse.map((dataPoint, index) => (
                      <li key={dataPoint.expression + index}>
                        {dataPoint.expression} - {dataPoint.label}
                      </li>
                    ))}
                  </ul>
                }
                {this.state.setSalesCatalystBaseFlag === true &&
                  <ul>
                    {this.state.emptyResponse.map((dataPoint, index) => (
                      <li key={dataPoint.expression + index}>
                        {dataPoint.expression} {this.props.salesCatalystBase !== undefined ?
                          `& ${this.props.salesCatalystBase.expression}` : ''} - {dataPoint.label}
                        &nbsp;{this.props.salesCatalystBase.label !== undefined ? `& ${this.props.salesCatalystBase.label}` : ''}
                      </li>
                    ))}
                  </ul>
                }
              </div>

            </div>
            {!this.state.resultForTemplateChange &&
              <div className="text-right">
                {this.state.setSalesCatalystBaseFlag === false && !this.state.hideOkButton &&
                  <GenericButton
                    name="Cancel"
                    btnStyle="button btn-cncl margin-right-10"
                    onBtnClick={() => {
                      this.validateStudyResultModal.hide();
                      this.resetSelectedSCStudy();
                    }}
                  />
                }
                <GenericButton
                  name="Ok"
                  btnStyle="button btn-cncl"
                  btnDisabled={this.state.activateApplyBtn}
                  onBtnClick={() => {
                    this.state.setSalesCatalystBaseFlag === true ?
                      this.resetAfterBaseApplyFailure() :
                      this.applySelectedSCStudyAfterReset();
                    this.validateStudyResultModal.hide();
                    this.setPreferenceFlag(false);
                  }}
                />
              </div>}
            {this.state.resultForTemplateChange && <div className="text-right">
              <GenericButton
                name="Ok"
                btnStyle="button btn-cncl"
                btnDisabled={this.state.activateApplyBtn}
                onBtnClick={() => {
                  this.setState({ resultForTemplateChange: false });
                  this.validateStudyResultModal.hide();
                }}
              />
            </div>}
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => (this.confirmationModal = node)}
          dialogStyles={modalSettingStyle}
          afterClose={this.onModalPopupXButtonClick}
        >
          <div className="text-center">
            <div className="">
              <SaveDefinitionLabelPopupScreen
                definitionTree={this.props.definitionTree}
                personaHeaderLabelUpdateObject={
                  this.state.baseLabelUpdateObject
                }
                onPersonaHeaderLabelSave={this.onPersonaHeaderLabelSave}
                productNo={this.props.productNo}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => (this.configurationScreen = node)}
          dialogStyles={modalConfigurationStyle}
          headerStyles={{ display: 'none' }}
          afterClose={() => this.showSCConfigurations(false)}
          isDragDisabled
          normalize
        >
          <SalesCatalystConfigurationScreen
            nodeRef={this.configurationScreen}
            addInputDataPointsSelection={this.addInputDataPointsSelection}
          />
        </Modal>
        <div className="large-12 columns" />
        <div className="row fullWidth">
          <div className="large-12">
            <div className="salescatalyst-appBreadcrumb clearfix">
              <div className="left-heading">
                <CommonStudySelector
                  studies={this.props.studies}
                  featureID={SALES_CATALYST_FEATUREID}
                  defaultStudy={this.state.smartSearchStudy}
                  dataOnScreen={this.checkSCTabHasData}
                  alertMsg="This selection will impact all of the Sales Catalyst modules"
                  setMethod={this.setSelectedSCStudy}
                  resetMethod={click => (this.resetSelectedSCStudy = click)}
                />
              </div>
              <p>
                <span className="parent">Catalyst / </span>
                {SALES_CATALYST}
                {
                  /*
                  (!this.props.universityUser) &&
                  <button className="margin-left-5" onClick={() => this.showSCConfigurations(true, 2)}>
                    <img className="sc-icon-img" src={settingsIcon} alt="Settings" />
                  </button> */
                }
              </p>
            </div>
          </div>
        </div>
        <div className="smart-search-editor">
          <div className="clearfix">
            <SmartSearch
              selectedModule="salescatalyst"
              moduleStudy={this.state.smartSearchStudy}
              getSampleWeighted={
                this.props.quickReportsActions.getSampleWeighted
              }
              fetchKPI={this.props.crosstabActions.fetchKPI}
              removeKPI={this.props.crosstabActions.removeCrossTabKpiInfo}
              gridData={this.getGridData()}
              dataScreen="salescatalyst"
              selectedTab={this.props.selectedTab}
              setSalesCatalystBase={this.setSalesCatalystBase}
              addInputDataPointsSelection={this.addInputDataPointsSelection}
              resetSalesCatalyst={this.resetSalesCatalyst}
              resetInputInfo={this.state.ssResetInputInfo}
              ref={this.smartSearchBox}
            />
            <div className="move-to-salescatalyst-wrapper">
              <div className="insight360-button-group">
                {this.state.baseBtnDisabled ? (
                  <div className="display-inline-block">
                    <GenericButton
                      name="Assign"
                      btnStyle="i360-smart-search-button create-btn"
                      btnDisabled
                    />
                    <GenericButton
                      name="Base"
                      btnStyle="i360-smart-search-button base-btn"
                      btnDisabled
                    />
                  </div>
                ) : (
                    <div className="display-inline-block button-group-tooltip i360-smart-search-tooltip">
                      {this.state.smartSearchDataOptions &&
                        !_.reduce(this.state.smartSearchDataOptions, (status, n) => {
                          if (availableToAddSpecificSelection(this.props.scDataSelection, n) && status) {
                            status = false;
                          }
                          return status;
                        }, true) ?
                        <DropdownButton
                          className="btn-group"
                          title="Assign"
                          noCaret
                          id="Assign"
                          show={this.state.popupApplyVisible}
                          onToggle={() =>
                            this.setState({
                              popupApplyVisible: !this.state.popupApplyVisible,
                            })
                          }
                        >
                          {_.map(this.state.smartSearchDataOptions, data => {
                            return availableToAddSpecificSelection(this.props.scDataSelection, data) ? (
                              (data !== 'Brand') && <li
                                onClick={() =>
                                  this.validateAddSpecificSelection(this.props.scDataSelection,
                                    data,
                                    SALES_CATALYST_DATA_SELECTION)}
                                key={data}
                              >{(data === SALES_CATALYST_DATA_COMPETITOR) ?
                                `${`${data}(${this.props.scDataSelection[_.camelCase(data)].length}/${SALES_CATALYST_MAX_COMPETITORS})`}`
                                : data}
                              </li>
                            ) :
                              ((data !== 'Brand') && <li className="disabled-item" key={data}>{(data === SALES_CATALYST_DATA_COMPETITOR) ?
                                `${`${data}(${this.props.scDataSelection[_.camelCase(data)].length}/${SALES_CATALYST_MAX_COMPETITORS})`}`
                                : data}</li>);
                          })}
                        </DropdownButton>
                        : <GenericButton
                          name="Assign"
                          btnStyle="i360-smart-search-button create-btn"
                          btnDisabled
                        />}
                      <GenericButton
                        name="Base"
                        btnStyle={this.state.baseBtnDisabled ||
                          (this.state.salesCatalystBase && !_.isEmpty(this.state.salesCatalystBase))
                          ? 'i360-smart-search-button base-btn'
                          : 'i360-smart-search-button base-btn active-btn'
                        }
                        onBtnClick={() => this.setSalesCatalystBase()}
                        btnDisabled={this.state.baseBtnDisabled ||
                          (this.state.salesCatalystBase && !_.isEmpty(this.state.salesCatalystBase))}
                      />
                    </div>)}
                <div className="display-inline-block">
                  {this.state.smartSearchDataOptions &&
                    _.reduce(this.state.smartSearchDataOptions, (status, n) => {
                      if (!availableToAddSpecificSelection(this.props.scDataSelection, n) && !status) {
                        status = true;
                      }
                      if (this.props.selectedTab === SALES_CATALYST_COMPETITION &&
                        this.props.scDataSelection[_.camelCase(SALES_CATALYST_DATA_COMPETITOR)]
                          .length > 0) {
                        status = true;
                      }
                      return status;
                    }, false) ? (
                      <GenericButton
                        btnStyle="i360-smart-search-button active-btn reset-btn"
                        name="Reset"
                        onBtnClick={() => this.resetSalesCatalyst()}
                      />
                    ) : (
                      <GenericButton
                        btnStyle="i360-smart-search-button reset-btn"
                        name="Reset"
                        btnDisabled
                      />
                    )}
                  {this.props.scDataOnScreen &&
                    this.state.smartSearchDataReqOptions &&
                    !this.props.scDataOnScreen[_.camelCase(this.props.selectedTab)] &&
                    _.reduce(this.state.smartSearchDataReqOptions, (status, n) => {
                      if (availableToAddSpecificSelection(this.props.scDataSelection, n, true) && status) {
                        status = false;
                      }
                      return status;
                    }, true) ? (
                      <GenericButton
                        btnStyle="i360-smart-search-button active-btn run-btn"
                        name=""
                        onBtnClick={() => this.runSalesCatalyst()}
                      />
                    ) : (
                      <GenericButton
                        btnStyle="i360-smart-search-button run-btn"
                        name=""
                        btnDisabled
                      />
                    )}
                </div>
                <div>
                  <div className="scSampleErrorMsg">
                    <p className="error-text">
                      {this.props.kpiInfo && this.props.kpiInfo.intab &&
                        this.props.kpiInfo.intab <= 0 ? SALES_LESS_BASE_WARNING : ''}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {(this.state.salesCatalystBase !== undefined &&
            this.state.salesCatalystBase.length !== 0) && (
              <div className="padding-top-10 sc-wrap-base">
                BASE:&nbsp;
              <InlineEdit
                textVal={this.state.salesCatalystBase.label}
                editBlockWidth="100%"
                icon={editIconActive}
                editFunction={this.toggleBaseEditMode}
                updateFn={this.updateBaseHeaderLabel}
                validateFn={this.validateBaseHeaderLabel}
                editViewClass="sc-cmn-edit-block"
              />
                {!this.state.isBaseInEditMode && <img
                  className="i360_header_icons_img i360_header_icons_img"
                  src={clearBaseIcon}
                  alt="Remove"
                  onClick={() => {
                    this.handleClearSalesBaseClick();
                  }}
                />}
              </div>)}
        </div>
        {this.props.selectedTab === SALES_CATALYST_TARGET_MARKET &&
          <SalesCatalystTargetMarket color={this.props.color} />
        }
        {this.props.selectedTab === SALES_CATALYST_MEDIA_PACKAGE &&
          <SalesCatalystMediaPackage color={this.props.color} />
        }
        {this.props.selectedTab === SALES_CATALYST_INPUTS && <SalesCatalystInputsTable
          brandAudience={this.state.brandSelection.audience}
          pitchAudience={this.state.pitchSelection.audience}
          brandsubAudience={this.state.brandSelection.subAudience}
          pitchsubAudience={this.state.pitchSelection.subAudience}
          brandCompetitors={this.state.brandSelection.competitors}
          pitchCompetitors={this.state.pitchSelection.competitors}
          brandMarket={this.state.brandSelection.market}
          pitchMarket={this.state.pitchSelection.market}
          smartSearchStudy={this.state.smartSearchStudy}
          salesCatalystBase={this.state.salesCatalystBase}
          brandSelection={this.state.brandSelection}
          pitchSelection={this.state.pitchSelection}
          selectedTemplates={this.state.selectedTemplates}
          showValidateStudyPopup={this.showValidateStudyResultPopup}
        />}
        {this.props.selectedTab === SALES_CATALYST_COMPETITION &&
          <SalesCatalystCompetition color={this.props.color} />
        }
      </div>
    );
  }
}
SalesCatalystContent.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  brandSelection: PropTypes.shape({}),
  pitchSelection: PropTypes.shape({}),
  activeAccountId: PropTypes.number,
  productNo: PropTypes.number,
  selectedTemplates: PropTypes.shape({}),
  salesCatalystBase: PropTypes.shape({}),
  smartSearchStudy: PropTypes.shape({}),
  salesCatalystStudyInfo: PropTypes.shape({
    ss: PropTypes.string,
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  salesCatalystActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    updateSelectionsData: PropTypes.func,
    attitudeMarketDataList: PropTypes.func,
    handleClearSalesBaseClick: PropTypes.func,
    showCofigurationScreen: PropTypes.func,
    resetSalesCatalystScreen: PropTypes.func,
    resetSalesCatalyst: PropTypes.func,
    getDemoMarketDataList: PropTypes.func,
    runSalesCatalyst: PropTypes.func,
    setSalesBase: PropTypes.func,
    setDataOnScreenVal: PropTypes.func,
    addSalesCatalystDataPoints: PropTypes.func,
    getSalesHeaderInfo: PropTypes.func,
    setCofigurationPackageData: PropTypes.func,
    deleteSalesCatalystSelection: PropTypes.func,
    updateDataOnScreen: PropTypes.func,
    setSalesCatalystStudy: PropTypes.func,
    getSampleWeightedReachInfo: PropTypes.func,
    getActivitiesTemplateList: PropTypes.func,
    saveDataToDefinitionFolder: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    setSalesCatalystStudy: PropTypes.func,
  }),
  definitionTree: PropTypes.arrayOf(PropTypes.object),
  dataOnScreen: PropTypes.shape({}),
  configPopupShow: PropTypes.shape({}),
  salesCatalystPrefenceFlag: PropTypes.bool,
  preferencesActions: PropTypes.func,
  selectedTab: PropTypes.string,
  quickReportsActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    fetchKPI: PropTypes.func,
    removeCrossTabKpiInfo: PropTypes.func,
  }),
  scDataSelection: PropTypes.shape({
    targetMarket: PropTypes.arrayOf(PropTypes.object),
    entity: PropTypes.arrayOf(PropTypes.object),
    competitor: PropTypes.arrayOf(PropTypes.object),
    brand: PropTypes.arrayOf(PropTypes.object),
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
  }),
  kpiInfo: PropTypes.shape({}),
  activitiesTemplateList: PropTypes.shape({}),
  sessionData: PropTypes.shape({}),
  universityUser: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    brandSelection: state.salesCatalyst.brandSelection,
    pitchSelection: state.salesCatalyst.pitchSelection,
    salesCatalystBase: state.salesCatalyst.salesCatalystBase,
    studies: state.study.salesCatalystStudies,
    activeAccountId: state.account.activeAccountId,
    selectedTemplates: state.salesCatalyst.selectedTemplates,
    kpiInfo: state.crosstab.kpiInfo,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    studySource: typeof state.study.salesCatalystStudy !== 'undefined' &&
    typeof state.study.salesCatalystStudy.ss !== 'undefined' ?
    state.study.salesCatalystStudy.pn : 0,

    entity: state.salesCatalyst.dataSelection.entity,
    competitor: state.salesCatalyst.dataSelection.competitor,
    targetMarket: state.salesCatalyst.dataSelection.targetMarket,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
    dataOnScreen: state.salesCatalyst.dataOnScreen,
    targetOnScreen: state.salesCatalyst.dataOnScreen.targetMarket,
    scAttitudesDisplayList: state.salesCatalyst.scAttitudesDisplayList,
    scDemoDisplayList: state.salesCatalyst.scDemoDisplayList,
    scDataSelection: state.salesCatalyst.dataSelection,
    configPopupShow: state.salesCatalyst.scConfiguration.configPopupShow,

    salesCatalystStudyInfo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy !== 'undefined' ?
      state.study.salesCatalystStudy : [],
    salesCatalystPrefenceFlag: state.preferences.preferenceFlags.salesCatalyst,
    scDataOnScreen: state.salesCatalyst.dataOnScreen,
    activitiesTemplateList: state.salesCatalyst.activitiesTemplateList,
    sessionData: state.salesCatalyst.scSessionConfiguration,
    universityUser: state.login.loginResponse.data.universityUser || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    definitionActions: bindActionCreators(definitionActions, dispatch),
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    preferencesActions: bindActionCreators(preferencesActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesCatalystContent);
